
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';
import FactData from '../../data/brand/FactData.json';





// import required modules
import SwiperCore, { Mousewheel, Pagination } from "swiper";

import './FactSlider.css'


const FactSlider = () => {

    SwiperCore.use([Mousewheel, Pagination ]);

    return (
        // <div className="section section mt-5 mb-15" data-aos="fade-up"  height="500px">
        //     <div className="section">
        <span style={{position:'relative'}}>
            <Swiper 
                modules={[Mousewheel, Pagination]}
                direction={"vertical"}
                slidesPerView={1}
                spaceBetween={0}
                mousewheel={true}
                pagination={{
                clickable: true
                }}
                // loop={true}
                className="mySwiper fact"
            >
{FactData && FactData.map((single, key) => {  
    return(
        <SwiperSlide className="factSlide" key={key}> 
                    {/* <div className=' ' style={{backgroundColor:'#EEEEEE', height:'100%'}}> */}
                        <div className="row-container" style={{backgroundColor:'#EEEEEE', height:'70vh'}}>
                        <div className='row factSlider-row Lres' >
                        
                            <div className='col-7 factSlider-img-div ' style={{}}>
                                <img className="factSlider-img Lres" src={single.image} style={ {  height:'70vh'}} ></img>
                            </div>
                            <div className='col factSlider-text-div' style={{ textAlign:'left'}}>
                                <h1 className="fact-title" style={{margin:'5% 0 2% 0'}}>
                                    <strong style={{fontSize:'1.2rem',fontWeight:'normal', background:'#030e22',color:'white',padding:'5px 20px'}}>{single.Ftitle}</strong><span style={{marginLeft:'4px',fontSize:'1.2rem',fontWeight:'normal', background:'#2ea3f2',color:'white',padding:'5px 10px'}}>{single.Fnum}</span><h1 style={{fontSize:'1.5rem',marginTop:'5px'}}>{single.headerNum}</h1>
                                </h1>
                                <p className="fact-desc" style={{color:'black', marginRight:'20%'}}>{single.desc}</p>
                            </div>
                        </div>
                    </div>
        </SwiperSlide>
    )

})}
                    {/* {YantCards && YantCards.map((single, key) => { */}
                        {/* return( */}
                                                {/* <SwiperSlide > */}
                                                    
                                                    {/* <div className=' section-paddingTopBottom' style={{backgroundColor:'#EEEEEE', paddingTop:'5%'}}>
                                                   <div className='row' >
                                                     <div className='col-7' >

                                                     </div>

                                                     <div className='col' style={{marginRight:'15%'}}>
                                                     <h1 style={{marginBottom:'30px'}}>
						                                <strong style={{fontSize:'1.2rem',fontWeight:'normal', background:'#030e22',color:'white',padding:'5px 20px'}}>Fact</strong><span style={{marginLeft:'4px',fontSize:'1.2rem',fontWeight:'normal', background:'#2ea3f2',color:'white',padding:'5px 10px'}}>01</span>
					                                </h1>
                                                    <p>
                                                        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Optio officia deleniti natus repellendus error voluptatibus consequuntur earum. Reprehenderit, quis animi tempora ex molestiae,
                                                    </p>
                                                         </div>

                                                   </div>
                                                   </div> */}
                                                {/* <div className="card align-items-center" style={{width: "15rem",backgroundColor:'#030e22',border:'none',textAlign:'left',borderRadius:'10px'}}>
                                                    <img src={single.image} className="card-img-top " alt="..." style={{ maxWidth:'200px', margin:'30px auto 0px auto',verticalAlign:'center',alignItems:'center'}}/>
                                                    <div className="card-body">
                                                       
                                                    </div>
                                                  
                                                    <div className="card-body hoverCard" style={{minHeight:'200px',padding:'20px 30px'}}>
                                                        <h4 style={{ marginBottom:'10px',
                                                            fontWeight: '900',
                                                            fontSize: 'clamp(1.5rem * 0.8, 2vw, 0.5rem)',
                                                            lineHeight: '1.35',
                                                            color: '#2ea3f2 '}}>{single.title}</h4>
                                                            <p className="desc" style={{color:'#fff'}}>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Et odit libero </p>
                                                    </div>
                                                    </div>      */}

                                                {/* </SwiperSlide> */}
                                                {/* <SwiperSlide>Slide 2</SwiperSlide> */}
                        {/* )
                                        })} */}
{/*                                           
                                                <SwiperSlide style={{margin:'0px 0px'}} >
                                                <div className="card" style={{width: "15rem",backgroundColor:'#030e22',border:'none',textAlign:'left',borderRadius:'10px'}}>
                                                    <img src="images/computer.png" className="card-img-top" alt="..." style={{ maxWidth:'200px',margin:'15px auto 0px auto'}}/>
                                                    <div className="card-body">
                                                       
                                                    </div>
                                                  
                                                    <div className="card-body hoverCard" style={{minHeight:'200px',padding:'20px 30px'}}>
                                                        <h4 style={{ marginBottom:'10px',
                                                            fontWeight: '900',
                                                            fontSize: 'clamp(1.5rem * 0.8, 2vw, 0.5rem)',
                                                            lineHeight: '1.35',
                                                            color: '#2ea3f2 '}}>Medical Offices</h4>
                                                            <p className="desc" style={{color:'#fff'}}>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Et odit libero </p>
                                                    </div>
                                                    </div>     

                                                </SwiperSlide>

                                                <SwiperSlide style={{margin:'0px 0px'}}>
                                                <div className="card" style={{width: "15rem",backgroundColor:'#030e22',border:'none',textAlign:'left',borderRadius:'10px'}}>
                                                    <img src="images/computer.png" className="card-img-top" alt="..." style={{ maxWidth:'200px',margin:'15px auto 0px auto'}}/>
                                                    <div className="card-body">
                                                       
                                                    </div>
                                                  
                                                    <div className="card-body hoverCard" style={{minHeight:'200px',padding:'20px 30px'}}>
                                                        <h4 style={{ marginBottom:'10px',
                                                            fontWeight: '900',
                                                            fontSize: 'clamp(1.5rem * 0.8, 2vw, 0.5rem)',
                                                            lineHeight: '1.35',
                                                            color: '#2ea3f2 '}}>Physical Theraphy Clinics</h4>
                                                            <p className="desc" style={{color:'#fff'}}>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Et odit libero </p>
                                                    </div>
                                                    </div>     

                                                </SwiperSlide>   */}
      
                                </Swiper>
                            {/* // </div> */}
                            </span>
                        /* </div>
                        
                        </div> */
                    /* </div>

                </div>

            </div> */
        // </div>
    )
}

export default FactSlider;
